import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";


import './SolarPlant.css'
import SolarBanner from '../components/SolarBanner'
import Nabar from "../components/Navbar"
import Footer from "../components/Footer"
import ONGRID from '../images/SolarPlants/ONGRID.jpeg'
import OFFGRID from '../images/SolarPlants/OFFGRID.jpeg'
import HYBRIDSOLAR from '../images/SolarPlants/HYBRIDSOLAR.jpeg'
import ROOFTOPSOLAR from '../images/SolarPlants/ROOFTOPSOLAR.jpeg'
import GROUNDMOUNTEDSOLAR from '../images/SolarPlants/GROUNDMOUNTEDSOLAR.jpg'
import CORPORATESOLARPLANT from '../images/SolarPlants/CORPORATESOLARPLANT.jpg'
import STREETLIGHTINSTALL from '../images/SolarPlants/STREETLIGHTINSTALL.jpg'
import SOLARWATERHEATER from '../images/SolarPlants/SOLARWATERHEATER.jpg'
import LIGHTINGARRESTER from '../images/SolarPlants/LIGHTINGARRESTER.jpg'
import LIGHTINGAREESTORVID from '../images/SolarPlants/LIGHTINGAREESTORVID.mp4'
import Picture1 from '../images/SolarPlants/Picture1.png'
import Picture3 from '../images/SolarPlants/Picture3.png'
import ONGRIDSVID from '../images/SolarPlants/ONGRIDSVID.mp4'
import SOLARINSTALLVID from '../images/SolarPlants/SOLARINSTALLVID.mp4'
import OFFGRIDVID from '../images/SolarPlants/OFFGRIDVID.mp4'
import ROOFTOPINSTALLVID from '../images/SolarPlants/ROOFTOPINSTALLVID.mp4'
import GROUNDMOUNTVID from '../images/SolarPlants/GROUNDMOUNTVID.mp4'
import CARPORTVIDEO from '../images/SolarPlants/CARPORTVIDEO.mp4'
import SOLARSTREETLIGHT from '../images/SolarPlants/SOLARSTREETLIGHT.mp4'
import ROOFTOPWATER from '../images/SolarPlants/ROOFTOPWATER.mp4'
import HYBRIDVID from '../images/SolarPlants/HYBRIDVID.mp4'
import HYBRIDVIDIMG from '../images/SolarPlants/HYBRIDVIDIMG.png'



import {
  MdOutlineLightbulb,
  MdPowerOff,
  MdAutorenew,
  MdAltRoute,

  MdPark,
  MdNaturePeople
} from "react-icons/md";


import {
  MdDirectionsCar,



  MdHotel,
  MdElectricCar,
  MdEngineering,

  MdBolt,
  MdVerified,


  MdEco
} from "react-icons/md";






import {
  MdSolarPower,
  MdBatteryChargingFull,
  MdPower,


  MdSchool
} from "react-icons/md";




import {
  MdOutlineSolarPower,
  MdApartment,

  MdNightsStay
} from "react-icons/md";

import {
  MdFlashOn,
  MdSecurity,
  MdHome,
  MdFactory,
  MdBusiness,
  MdLocalHospital,
  MdCellTower,
  MdLandscape,
  MdElectricalServices,
  MdCheckCircle
} from "react-icons/md";


import {
  MdOutlineBatteryChargingFull,
  MdOutlinePower,
  MdOutlineHome,
  MdOutlineAgriculture,
  MdOutlineConstruction,
  MdOutlineSignalCellularAlt,
  MdOutlineLandscape,
  MdOutlineMedicalServices,
  MdOutlineWater
} from "react-icons/md";

import {
  // MdSolarPower,
  // MdBuild,
  MdTrendingUp,
  MdPublic,
  // MdFlashOn,
  MdDeleteSweep
} from "react-icons/md";


import {
  MdRoofing,

  // MdBatteryChargingFull,
  // MdPower,
  // MdHome,
  MdAssessment,
  MdWbSunny,
  MdWaterDrop,
  MdBuild
} from "react-icons/md";



export default function SolarPlant() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [openIndex, setOpenIndex] = useState(null);

  const toggleCard = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const solarData = [
    {
      img: ONGRID,
      title: "On-Grid Solar Power Plant",
      content: `• Connected with EB electricity grid
• Solar panels generate power during daytime
• Excess electricity sent back to grid
• Reduces monthly electricity bill
• Ideal for homes & commercial buildings`
    },
    {
      img: OFFGRID,
      title: "Off-Grid Solar Power Plant",
      content: `• Works independently without EB grid
• Solar panels charge battery during daytime
• Battery provides power at night
• Best for rural & remote locations
• Provides full power backup`
    },
    {
      img: HYBRIDSOLAR,
      title: "Hybrid Solar Power Plant",
      content: `• Combination of grid + battery system
• Solar power used first before EB power
• Battery backup during power cuts
• Stores extra solar energy
• Ideal for uninterrupted electricity`
    },
    {
      img: ROOFTOPSOLAR,
      title: "Rooftop Solar Installation",
      content: `• Installed on building rooftop
• Uses unused roof space effectively
• Reduces electricity bill up to 70%
• Suitable for homes & industries
• Government subsidy available`
    },
    {
      img: GROUNDMOUNTEDSOLAR,
      title: "Ground-Mounted Solar Power Plant",
      content: `• Installed directly on land
• Suitable for large solar plants
• Higher efficiency panel alignment
• Easy maintenance access
• Used in solar farms & industries`
    },
    {
      img: CORPORATESOLARPLANT,
      title: "Solar Carport / Canopy Installation",
      content: `• Installed above parking area
• Provides shade for vehicles
• Generates solar electricity
• Dual-purpose parking solution
• Used in malls & commercial spaces`
    },
    {
      img: STREETLIGHTINSTALL,
      title: "Solar Street Light Installation",
      content: `• Solar panel charges battery in daytime
• Automatically lights up at night
• No electricity bill required
• Ideal for roads & public areas
• Eco-friendly lighting system`
    },
    {
      img: SOLARWATERHEATER,
      title: "Solar Water Heating Systems",
      content: `• Uses sunlight to heat water
• Reduces electricity consumption
• Suitable for homes & hotels
• Low maintenance system
• Eco-friendly water heating`
    },
    {
      img: LIGHTINGARRESTER,
      title: "Lightning Arrester",
      content: `• Protects solar system from lightning
• Safely diverts electrical surge to ground
• Prevents inverter damage
• Improves electrical safety
• Essential protection device`
    }
  ];
  return (
    <>
      <Helmet>
        <title>Solar Panel Installation in Madurai | On-Grid & Off-Grid Solar Plants</title>
        <meta name="description" content="Get high-quality solar panel installation in Madurai. We offer On-Grid, Off-Grid, and Hybrid solar power systems for homes and businesses. Save on electricity bills with RAD EnviroNex." />
        <meta name="keywords" content="Solar Panel Installation Madurai, On-Grid Solar Power Plant, Off-Grid Solar Madurai, Hybrid Solar System, Rooftop Solar Installation, Solar for Industries Madurai" />
        <link rel="canonical" href="https://radenvironex.com/SolarPlant" />
      </Helmet>
      <Nabar />

      <SolarBanner />


      <section id="solar-plant-about" className="solar-about-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10" data-aos="slide-up">

              <div className="solar-about-box">
                <h2 className="solar-about-title">About Solar Energy</h2>

                <p className="solar-about-text">
                  "At RAD EnviroNex, we believe solar energy is not just an alternative—it is the future. With rising electricity costs and increasing concern about climate change, solar power has become one of the most reliable solutions for homes, hospitals, commercial buildings, and industries. Solar systems help reduce carbon emissions, lower electricity bills, and provide long-term energy security.Our solar solutions are designed to support India’s vision of Net Zero Carbon Emission while delivering efficient, reliable, and cost-effective power solutions.
                </p>


                {/* BENEFITS */}
                {/* <div className="solar-benefits">
            <h3 className="benefits-title">Key Benefits of Solar Energy</h3>

            <ul className="benefits-list">
              <li>🌞 Clean & eco-friendly power</li>
              <li>💰 Significant reduction in electricity bills</li>
              <li>🌍 Zero carbon emissions</li>
              <li>🔋 Low maintenance & long system life</li>
              <li>🇮🇳 Supports India’s renewable energy mission</li>
            </ul>
          </div> */}

              </div>

            </div>
          </div>
        </div>
      </section>
      {/* 
 <section id="Solar-install-type" className="solar-install-section">
      <div className="container">

       
        <div className="row mb-5">
          <div className="col-12 text-center">
            <h2 className="solar-install-title">Solar Installation Types</h2>
            <p className="solar-install-sub">
              We deliver customized solar solutions for every application and scale
            </p>
          </div>
        </div>

      
        <div className="row g-4">

          {solarData.map((item, index) => (
            <div className="col-lg-4 col-md-6 col-12" key={index}>

              <div className="solar-install-card">

                <img src={item.img} alt={item.title} />

                <h4>{item.title}</h4>

                <div
                  className="view-more-btn"
                  onClick={() => toggleCard(index)}
                >
                  View More
                  <span className={openIndex === index ? "arrow rotate" : "arrow"}>
                    ▼
                  </span>
                </div>

                {openIndex === index && (
                  <div className="solar-detail">
                    <p style={{ whiteSpace: "pre-line" }}>
                      {item.content}
                    </p>
                  </div>
                )}

              </div>

            </div>
          ))}

        </div>

      </div>
    </section> */}

      {/* 
<section id="why-rad-solar" className="why-rad-solar-section">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-11" data-aos="slide-up">

        <h2 className="why-rad-title">Why RAD for Solar?</h2>

        <p className="why-rad-intro">
          At RAD EnviroNex, solar installation begins long before panels reach
          the site. Our strength lies in precise planning, engineering
          discipline, and data-driven system design that ensures long-term
          performance, safety, and return on investment.
        </p>

        
        <div className="why-rad-step">
          <span className="step-no">01</span>
          <h4>Site Assessment & Feasibility Study</h4>
          <p>
            We conduct a detailed site survey to evaluate roof or ground
            availability, structural strength, orientation, shading impact,
            local climate conditions, and solar irradiation levels. This
            assessment ensures the proposed solar system is technically and
            practically viable.
          </p>
        </div>

        <div className="why-rad-step">
          <span className="step-no">02</span>
          <h4>Energy Requirement Analysis</h4>
          <p>
            Our engineers analyze monthly and annual electricity consumption,
            peak load demand, and future expansion needs. This allows accurate
            system sizing that meets both present and future energy
            requirements without over- or under-design.
          </p>
        </div>

        
        <div className="why-rad-step">
          <span className="step-no">03</span>
          <h4>System Design & Layout Planning</h4>
          <p>
            We design a customized solar PV layout including optimal panel
            placement, tilt angle, inverter configuration, DC and AC wiring
            routes, and mounting structure design. Professional simulation
            tools are used to maximize energy generation and system efficiency.
          </p>
        </div>

        <div className="why-rad-step">
          <span className="step-no">04</span>
          <h4>Component Selection</h4>
          <p>
            Only high-quality and certified components are selected—high-
            efficiency solar panels, reliable inverters, durable mounting
            structures, and essential safety and protection equipment—ensuring
            durability, performance, and compliance.
          </p>
        </div>

       
        <div className="why-rad-step">
          <span className="step-no">05</span>
          <h4>Financial & ROI Analysis</h4>
          <p>
            Before installation, we present a transparent financial assessment
            covering estimated energy generation, cost savings, payback
            period, and return on investment (ROI), helping clients make
            informed decisions.
          </p>
        </div>

       
        <div className="why-rad-step">
          <span className="step-no">06</span>
          <h4>Regulatory & Safety Compliance</h4>
          <p>
            Every system is designed in compliance with local electrical and
            building regulations, utility grid interconnection requirements,
            and environmental safety standards—ensuring smooth approvals and
            risk-free operation.
          </p>
        </div>

        <div className="why-rad-footer">
          Choosing RAD EnviroNex means investing in a solar partner that
          prioritizes engineering accuracy, compliance, and long-term
          performance—not just installation.
        </div>

      </div>
    </div>
  </div>
</section> */}


      {/* <section id="Picture-1" className="picture-section">
  <div
    className="picture-wrapper"
    data-aos="slide-up"
    data-aos-once="false"
  >
    <img src={Picture1} alt="Solar Plant Overview" />
  </div>
</section> */}


      {/* 
<section
  id="post-installation-solar"
  className="post-install-solar-section"
>
  <div className="container">
    <div
      className="post-install-card"
      data-aos="slide-up"
      data-aos-once="false"
    >
      <h2 className="post-install-title">
        How RAD EnviroNex Plans Solar Systems After Installation
      </h2>

      <p className="post-install-intro">
        At RAD EnviroNex, our responsibility doesn’t end with installation.
        We follow a structured post-installation planning and management
        process to ensure the solar system delivers maximum performance
        throughout its life.
      </p>

      <ul className="post-install-list">
        <li>
          <span>✔</span>
          <strong>System Testing & Commissioning</strong><br />
          Safe, stable, and efficient system operation from day one.
        </li>

        <li>
          <span>✔</span>
          <strong>Performance Benchmarking</strong><br />
          Baseline energy generation tracking for accuracy and reliability.
        </li>

        <li>
          <span>✔</span>
          <strong>Real-Time Monitoring</strong><br />
          Continuous tracking to detect faults and optimize output.
        </li>

        <li>
          <span>✔</span>
          <strong>Planned Maintenance</strong><br />
          Scheduled cleaning, inspections, and preventive checks.
        </li>

        <li>
          <span>✔</span>
          <strong>Energy Optimization Guidance</strong><br />
          Maximize self-consumption and reduce grid dependency.
        </li>

        <li>
          <span>✔</span>
          <strong>Compliance & Warranty Support</strong><br />
          Ongoing support for safety standards and warranty management.
        </li>
      </ul>
    </div>
  </div>
</section>
 */}

      {/* 
<section id="Picture-3" className="picture-section">
  <div
    className="picture-wrapper"
    data-aos="slide-up"
    data-aos-once="false"
  >
    <img src={Picture3} alt="Solar Plant Overview" />
  </div>
</section> */}


      {/* <section id="Picture-3" className="picture-section">
  <div
    className="picture-wrapper"
    data-aos="slide-up"
    data-aos-once="false"
  >
    <img src={Picture3} alt="Solar Plant Overview" />
  </div>
</section> */}




      <section id="solar-install-types" className="solar-install-section">
        <div className="container">

          {/* SECTION TITLE */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10 text-center" data-aos="slide-up">
              <h2 className="solar-install-title">
                Solar Installation Types
              </h2>
              <p className="solar-install-sub">
                Solar Installation Solutions by RAD EnviroNex
              </p>
              <p className="solar-install-desc">
                At RAD EnviroNex, we deliver end-to-end solar energy solutions designed
                to reduce carbon footprint, optimize energy costs, and support India’s
                Net-Zero vision. Our solar installations are engineered for
                performance, safety, and long-term sustainability.
              </p>
            </div>
          </div>

          {/* ON GRID SOLAR */}
          <div className="row justify-content-center">
            <div className="col-lg-10" data-aos="slide-up">

              <div className="solar-type-card">

                <h3 className="solar-type-title">
                  On-Grid Solar Power Systems
                </h3>

                <p className="solar-quote">
                  “Smart solar solutions for maximum savings”
                </p>

                <p className="solar-text">
                  An <strong>On-Grid Solar Power Plant</strong> (also called a
                  Grid-Connected Solar System) is connected directly to the electricity
                  grid (EB). It allows you to use solar power during the day and export
                  excess energy to the grid, helping you reduce electricity bills
                  significantly.
                </p>

                {/* WORKING */}
                <div className="row mt-4 g-4">

                  {/* DAY */}
                  <div className="col-md-6">
                    <div className="solar-work-box">
                      <h5><MdFlashOn /> Day Time</h5>
                      <ul>
                        <li>Solar panels generate electricity from sunlight</li>
                        <li>Power is used directly for home / office / industry</li>
                        <li>Extra electricity is sent to the EB grid</li>
                        <li>Net meter records the exported units</li>
                      </ul>
                    </div>
                  </div>

                  {/* NIGHT */}
                  <div className="col-md-6">
                    <div className="solar-work-box">
                      <h5><MdNightsStay /> Night Time</h5>
                      <ul>
                        <li>Solar panels do not generate power</li>
                        <li>Electricity is taken from the EB grid</li>
                        <li>Continuous power supply is maintained</li>
                        <li>Daytime solar credits reduce the bill</li>
                      </ul>
                    </div>
                  </div>

                </div>

                {/* BEST SUITABLE */}
                <div className="solar-suitable mt-4">
                  <h5 style={{ color: '#0bbcd6', textAlign: 'center' }} >Best Suitable For</h5>
                  <div className="suitable-list">
                    <span><MdHome /> Residential Buildings</span>
                    <span><MdLocalHospital /> Hospitals & Institutions</span>
                    <span><MdFactory /> Industries & Commercial Buildings</span>
                    <span><MdApartment /> Apartments & Offices</span>
                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>
      </section>




      <section
        id="Picture-3"
        className="picture-section3"
        style={{ backgroundImage: `url(${ONGRID})` }}
        aria-label="On-Grid Solar Power Plant Madurai"
      >
        <div
          className="picture-wrapper3"
          data-aos="slide-up"
          data-aos-once="false"
        >
          <video
            src={ONGRIDSVID}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="picture-video3"
          />
        </div>
      </section>









      <section id="offgrid-solar" className="offgrid-section">
        <div className="container">

          {/* TITLE */}
          <div className="row justify-content-center mb-5" data-aos="slide-up">
            <div className="col-lg-10 text-center">
              <h2 className="offgrid-title">Off Grid Solar System</h2>
              <p className="offgrid-tagline">
                Reliable power where the grid can’t reach
              </p>
            </div>
          </div>

          {/* DESCRIPTION */}
          <div className="row justify-content-center" data-aos="slide-up">
            <div className="col-lg-10">
              <p className="offgrid-text">
                An off-grid solar power plant is a standalone solar system that operates
                independently without connection to the electricity grid. It is ideal
                for locations where EB power is unavailable or unreliable.
              </p>
            </div>
          </div>

          {/* WORKING PRINCIPLE */}
          <div className="row g-4 mt-4">

            {/* DAY */}
            <div className="col-md-6" data-aos="slide-up">
              <div className="offgrid-card">
                <h4><MdOutlineSolarPower /> Day Time</h4>
                <ul>
                  <li>Solar panels generate electricity from sunlight</li>
                  <li>Power is used directly for loads</li>
                  <li>Extra energy is stored in batteries</li>
                  <li>Batteries get charged for night use</li>
                </ul>
              </div>
            </div>

            {/* NIGHT */}
            <div className="col-md-6" data-aos="slide-up">
              <div className="offgrid-card">
                <h4><MdOutlineBatteryChargingFull /> Night Time</h4>
                <ul>
                  <li>Solar panels stop generating power</li>
                  <li>Stored battery power supplies electricity</li>
                  <li>Inverter provides continuous AC power</li>
                  <li>No EB / grid power required</li>
                </ul>
              </div>
            </div>

          </div>

          {/* BEST SUITABLE */}
          <div className="row justify-content-center mt-5" data-aos="slide-up">
            <div className="col-lg-10">
              <h4 className="offgrid-subtitle" style={{ color: '#0bbcd6', textAlign: 'center' }}>Best Suitable For</h4>

              <div className="offgrid-uses">
                <span><MdOutlineHome /> Remote homes & villages (no EB supply)</span>
                <span><MdOutlineAgriculture /> Farms & agriculture pumps</span>
                <span><MdOutlineConstruction /> Construction sites</span>
                <span><MdOutlineSignalCellularAlt /> Telecom towers & security systems</span>
                <span><MdOutlineLandscape /> Hilly & forest areas</span>
                <span><MdOutlineMedicalServices /> Clinics & cold storage</span>
                <span><MdOutlineWater /> Water pumping & irrigation systems</span>
              </div>
            </div>
          </div>

        </div>
      </section>



      <section
        id="Picture-3"
        className="picture-section3"
        style={{ backgroundImage: `url(${OFFGRID})` }}
        aria-label="Off-Grid Solar Power Plant Installation Madurai"
      >
        <div
          className="picture-wrapper3"
          data-aos="slide-up"
          data-aos-once="false"
        >
          <video
            src={OFFGRIDVID}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="picture-video3"
          />
        </div>
      </section>








      {/* PICTURE 2 – VIDEO WITH BG ATTACHMENT */}
      {/* <section
  id="Picture-4"
  className="picture-section4"
  style={{ backgroundImage: `url(${ROOFTOPSOLAR})` }}
>
  <div
    className="picture-wrapper4"
    data-aos="slide-up"
    data-aos-once="false"
  >
    <video
      src={SOLARINSTALLVID}
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      className="picture-video4"
    />
  </div>
</section> */}










      <section id="hybrid-solar-system" className="hybrid-solar-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10" data-aos="slide-up" data-aos-once="false">

              <h2 className="hybrid-title">Hybrid (Grid-Grid) Solar System</h2>
              <p className="hybrid-tagline">
                “Grid power + solar + battery backup”
              </p>

              <p className="hybrid-desc">
                A Hybrid Solar Power Plant combines the benefits of On-Grid and
                Off-Grid solar systems. It is connected to the electricity grid and
                also includes battery storage, ensuring uninterrupted power supply
                even during power cuts.
              </p>

              {/* DAY TIME */}
              <div className="hybrid-block">
                <h4><MdSolarPower /> Day Time Working</h4>
                <ul>
                  <li><MdPower /> Solar panels generate electricity from sunlight</li>
                  <li><MdHome /> Solar power runs loads first</li>
                  <li><MdBatteryChargingFull /> Extra solar energy charges batteries</li>
                  <li><MdPower /> Excess power sent to grid (if net meter available)</li>
                  <li><MdPower /> Grid power used only if required</li>
                </ul>
              </div>

              {/* NIGHT TIME */}
              <div className="hybrid-block">
                <h4><MdBatteryChargingFull /> Night Time Working</h4>
                <ul>
                  <li>Solar panels stop generating power</li>
                  <li>Stored battery energy supplies electricity</li>
                  <li>Critical loads continue without interruption</li>
                  <li>Grid power takes over automatically if batteries discharge</li>
                </ul>
              </div>

              {/* BEST SUITABLE */}
              <div className="hybrid-block">
                <h4 style={{ color: '#0bbcd6', textAlign: 'center' }}>Best Suitable For</h4>
                <div className="hybrid-grid">
                  <span><MdHome /> Homes & Villas</span>
                  <span><MdLocalHospital /> Hospitals & Clinics</span>
                  <span><MdFactory /> Industries</span>
                  <span><MdBusiness /> Commercial Buildings</span>
                  <span><MdSchool /> Schools & Colleges</span>
                  <span><MdPower /> Areas with Frequent Power Cuts</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>






      {/* PICTURE 2 – VIDEO WITH BG ATTACHMENT */}
      <section
        id="Picture-5"
        className="picture-section5"
        style={{ backgroundImage: `url(${HYBRIDVIDIMG})` }}
        aria-label="Hybrid Solar System Madurai"
      >
        <div
          className="picture-wrapper4"
          data-aos="slide-up"
          data-aos-once="false"
        >
          <video
            src={HYBRIDVID}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="picture-video5"
          />
        </div>
      </section>



      <section
        id="rooftop-solar-installation"
        className="rooftop-solar-section"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-lg-10"
              data-aos="slide-up"
              data-aos-once="false"
            >

              <h2 className="rooftop-title">
                Rooftop Solar Installations
              </h2>

              <p className="rooftop-tagline">
                “Turn your rooftop into a power plant”
              </p>

              <p className="rooftop-desc">
                Rooftop solar installations turn your unused roof space into a
                power-generating asset. By installing solar panels on rooftops,
                you can produce clean electricity, reduce EB bills, and move
                towards energy independence.
              </p>

              {/* TYPES */}
              <div className="rooftop-block">
                <h4><MdSolarPower /> Types of Rooftop Solar Systems</h4>

                <div className="rooftop-types">
                  <span><MdPower /> On-Grid Rooftop Solar</span>
                  <span><MdBatteryChargingFull /> Hybrid Rooftop Solar</span>
                  <span><MdSolarPower /> Off-Grid Rooftop Solar</span>
                </div>
              </div>

              {/* WHY RAD */}
              <div className="rooftop-block">
                {/* <h4>Why Choose RAD EnviroNex for Rooftop Solar?</h4> */}

                <div className="rooftop-points">
                  {/* <div> */}
                  {/* <MdAssessment />
                    <strong>Roof Assessment</strong>
                    <ul>
                      <li>Roof strength to handle panel weight</li>
                      <li>Sufficient shadow-free area</li>
                      <li>South-facing / optimal tilt for best output</li>
                    </ul> */}
                  {/* </div> */}

                  {/* <div> */}
                  {/* <MdWaterDrop />
                    <strong>Weather & Drainage</strong>
                    <ul>
                      <li>Wind-load–resistant mounting</li>
                      <li>Proper water drainage protection</li>
                    </ul> */}
                  {/* </div> */}

                  {/* <div> */}
                  {/* <MdBuild />
                    <strong>Installation & Maintenance</strong>
                    <ul>
                      <li>Professional installation team</li>
                      <li>Easy access for cleaning & servicing</li>
                      <li>AMC / maintenance plan recommended</li>
                    </ul> */}
                  {/* </div> */}
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>






      {/* PICTURE 2 – VIDEO WITH BG ATTACHMENT */}
      <section
        id="Picture-6"
        className="picture-section6"
        style={{ backgroundImage: `url(${ROOFTOPSOLAR})` }}
        aria-label="Rooftop Solar Installation Madurai"
      >
        <div
          className="picture-wrapper4"
          data-aos="slide-up"
          data-aos-once="false"
        >
          <video
            src={ROOFTOPINSTALLVID}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="picture-video6"
          />
        </div>
      </section>










      <section
        id="ground-mounted-solar"
        className="ground-solar-section"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-lg-11"
              data-aos="slide-up"
              data-aos-once="false"
            >

              <h2 className="ground-title">
                Ground-Mounted Solar Power Plant
              </h2>

              <p className="ground-tagline">
                “Large-scale solar solutions for land-based power generation.”
              </p>

              <p style={{ color: '#ffffff', textAlign: 'center' }} className="ground-desc">
                A Ground-Mounted Solar Power Plant is installed on open land instead
                of rooftops. It is ideal for large-scale power generation where
                sufficient land is available, offering high efficiency, easy
                maintenance, and scalable capacity.
              </p>

              {/* BEST SUITABLE */}
              <div className="ground-block">
                <center>
                  <h4 style={{ color: '#0bbcd6', textAlign: 'center' }}> Best Suitable For</h4>
                </center>
                <div className="ground-list">
                  <span>🏭 Industries & Manufacturing Units</span>
                  <span>🏢 Commercial Campuses</span>
                  <span>🌾 Agricultural & Open Lands</span>
                  <span>🏫 Institutions & Government Projects</span>
                  <span>⚡ Utility-Scale Solar Plants</span>
                </div>
              </div>

              {/* WHY RAD */}
              {/* <div className="ground-block">
                <h4>Why Choose RAD EnviroNex?</h4>

                <div className="ground-features">
                  <div>
                    <MdTrendingUp />
                    <strong>Expert Site & Land Analysis</strong>
                    <p>Right layout, spacing & shadow study for maximum output</p>
                  </div>

                  <div>
                    <MdBuild />
                    <strong>Robust Mounting Structures</strong>
                    <p>Hot-dip galvanized structures for long life & wind safety</p>
                  </div>

                  <div>
                    <MdFlashOn />
                    <strong>End-to-End Execution</strong>
                    <p>Survey, installation, testing & commissioning</p>
                  </div>

                  <div>
                    <MdDeleteSweep />
                    <strong>EB & Statutory Approvals</strong>
                    <p>Complete support for grid connectivity & compliance</p>
                  </div>
                </div>
              </div> */}

              {/* BUSINESS VISION */}
              {/* <div className="ground-vision">
          <h4>
            <MdTrendingUp /> RAD EnviroNex Vision for Business
          </h4>

          <ul>
            <li>💰 Significant cost savings against rising tariffs</li>
            <li>📈 High ROI with large-scale generation</li>
            <li>⚡ Reliable power for uninterrupted operations</li>
            <li>📊 Scalable as business power demand grows</li>
            <li>🛠️ Lower maintenance cost due to ground access</li>
            <li>🌍 Improves ESG goals & green brand image</li>
            <li>🏭 Utilizes idle land as revenue asset</li>
            <li>📜 Eligible for policy & incentive benefits</li>
          </ul>
        </div> */}

            </div>
          </div>
        </div>
      </section>


      {/* PICTURE 2 – VIDEO WITH BG ATTACHMENT */}
      <section
        id="Picture-6"
        className="picture-section6"
        style={{ backgroundImage: `url(${GROUNDMOUNTEDSOLAR})` }}
        aria-label="Ground-Mounted Solar Power Plant Madurai"
      >
        <div
          className="picture-wrapper4"
          data-aos="slide-up"
          data-aos-once="false"
        >
          <video
            src={GROUNDMOUNTVID}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="picture-video6"
          />
        </div>
      </section>









      <section id="solar-carport" className="solar-carport-section">
        <div className="container">

          {/* TITLE */}
          <div className="text-center mb-5" data-aos="slide-up">
            <h2 className="solar-carport-title">
              Solar Carport / Canopy Installation
            </h2>
            <p className="solar-carport-sub">
              “Smart parking spaces that generate clean solar power.”
            </p>
          </div>

          {/* INTRO */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10" data-aos="fade-up">
              <p className="solar-carport-text">
                A Solar Carport (Canopy) is an intelligent structure where solar panels
                are installed above parking areas, generating clean electricity while
                providing shade and protection for vehicles. It allows productive use
                of open parking space without occupying rooftops or land.
              </p>
            </div>
          </div>

          {/* BEST SUITABLE */}
          <div className="row g-4 mb-5">
            <h4 style={{ color: '#0bbcd6', textAlign: 'center' }} className="section-subtitle" data-aos="slide-up">
              Best Suitable For
            </h4>

            {[
              { icon: <MdBusiness />, text: "Commercial Buildings & Offices" },
              { icon: <MdFactory />, text: "Industries & Factories" },
              { icon: <MdLocalHospital />, text: "Hospitals" },
              { icon: <MdSchool />, text: "Institutions & Campuses" },
              { icon: <MdHotel />, text: "Malls, Hotels & Resorts" },
              { icon: <MdDirectionsCar />, text: "Large Parking Areas" }
            ].map((item, i) => (
              <div className="col-md-4 col-sm-6" key={i} data-aos="slide-up">
                <div className="icon-card">
                  {item.icon}
                  <span>{item.text}</span>
                </div>
              </div>
            ))}
          </div>

          {/* WHY RAD */}
          {/* <div className="row g-4 mb-5">
            <h4 className="section-subtitle" data-aos="slide-up">
              Why RAD EnviroNex for Solar Carport?
            </h4>

            {[
              { icon: <MdEngineering />, text: "Custom carport design tailored to parking layout & load needs" },
              { icon: <MdSecurity />, text: "High-strength MS / GI structures with wind & weather resistance" },
              { icon: <MdElectricCar />, text: "EV-ready design with charging integration provision" },
              { icon: <MdBuild />, text: "Turnkey execution – design, fabrication, installation & commissioning" },
              { icon: <MdVerified />, text: "EB, net-metering & statutory safety compliance" },
              { icon: <MdBolt />, text: "O&M and AMC support for long-term performance" }
            ].map((item, i) => (
              <div className="col-md-6" key={i} data-aos="fade-up">
                <div className="feature-card">
                  {item.icon}
                  <p>{item.text}</p>
                </div>
              </div>
            ))}
          </div> */}

          {/* BUSINESS VALUE */}
          <div className="row g-4">
            <h4 style={{ color: '#0bbcd6', textAlign: 'center' }} className="section-subtitle" data-aos="slide-up">
              Business Value of Solar Carport
            </h4>

            {[
              { icon: <MdTrendingUp />, text: "Reduced energy costs through on-site solar generation" },
              { icon: <MdDirectionsCar />, text: "Monetizes parking space into revenue assets" },
              { icon: <MdElectricCar />, text: "Supports EV charging revenue opportunities" },
              { icon: <MdTrendingUp />, text: "Strong ROI & long-term savings with dual-use infrastructure" },
              { icon: <MdEco />, text: "Improves ESG score & green brand image" },
              { icon: <MdDirectionsCar />, text: "Protects vehicles from sun & weather exposure" }
            ].map((item, i) => (
              <div className="col-md-4 col-sm-6" key={i} data-aos="slide-up">
                <div className="value-card">
                  {item.icon}
                  <p>{item.text}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>





      {/* PICTURE 2 – VIDEO WITH BG ATTACHMENT */}
      <section
        id="Picture-6"
        className="picture-section6"
        style={{ backgroundImage: `url(${CORPORATESOLARPLANT})` }}
      >
        <div
          className="picture-wrapper4"
          data-aos="slide-up"
          data-aos-once="false"
        >
          <video
            src={CARPORTVIDEO}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="picture-video6"
          />
        </div>
      </section>














      <section id="solar-street-light" className="solar-streetlight-section">
        <div className="container">

          {/* TITLE */}
          <div className="text-center mb-5" data-aos="slide-up">
            <h2 className="streetlight-title">
              Solar Street Light Installation
            </h2>
            <p className="streetlight-sub">
              Standalone solar-powered lighting for roads, campuses & open areas
            </p>
          </div>

          {/* DESCRIPTION */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10" data-aos="fade-up">
              <p className="streetlight-text">
                Solar Street Lights are independent lighting systems powered by solar
                energy. They operate without grid electricity, delivering reliable
                illumination with zero electricity cost. These systems automatically
                charge during the day and provide consistent lighting at night,
                even during power cuts.
              </p>
            </div>
          </div>

          {/* KEY BENEFITS */}
          <div className="row g-4 mb-5">
            <h4 style={{ color: '#0bbcd6', textAlign: 'center' }} className="section-subtitle" data-aos="slide-up">
              Key Benefits
            </h4>

            {[
              { icon: <MdPowerOff />, text: "No electricity bill" },
              { icon: <MdOutlineLightbulb />, text: "Works during power cuts" },
              { icon: <MdAutorenew />, text: "Automatic ON / OFF operation" },
              { icon: <MdBuild />, text: "Low maintenance" },
              { icon: <MdBatteryChargingFull />, text: "Long life LED & battery" },
              { icon: <MdEco />, text: "Eco-friendly lighting solution" }
            ].map((item, i) => (
              <div className="col-md-4 col-sm-6" key={i} data-aos="slide-up">
                <div className="benefit-card">
                  {item.icon}
                  <span>{item.text}</span>
                </div>
              </div>
            ))}
          </div>

          {/* BEST SUITABLE */}
          <div className="row g-4">
            <h4 style={{ color: '#0bbcd6', textAlign: 'center' }} className="section-subtitle" data-aos="slide-up">
              Best Suitable For
            </h4>

            {[
              { icon: <MdAltRoute />, text: "Roads & Highways" },
              { icon: <MdHome />, text: "Residential Layouts" },
              { icon: <MdSchool />, text: "Campuses & Institutions" },
              { icon: <MdLocalHospital />, text: "Hospitals" },
              { icon: <MdNaturePeople />, text: "Villages & Rural Areas" },
              { icon: <MdPark />, text: "Parks & Open Spaces" }
            ].map((item, i) => (
              <div className="col-md-4 col-sm-6" key={i} data-aos="slide-up">
                <div className="use-card">
                  {item.icon}
                  <span>{item.text}</span>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>









      {/* PICTURE 2 – VIDEO WITH BG ATTACHMENT */}
      <section
        id="Picture-6"
        className="picture-section6"
        style={{ backgroundImage: `url(${STREETLIGHTINSTALL})` }}
      >
        <div
          className="picture-wrapper4"
          data-aos="slide-up"
          data-aos-once="false"
        >
          <video
            src={SOLARSTREETLIGHT}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="picture-video6"
          />
        </div>
      </section>






      <section id="solar-water-heating" className="solar-water-section">
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-lg-10"
              data-aos="slide-up"
              data-aos-once="false"
            >

              <h2 className="solar-water-title">
                Solar Water Heating Systems
              </h2>

              <p className="solar-water-tagline">
                “Efficient solar hot water solutions for homes and businesses.”
              </p>

              <p className="solar-water-text">
                Solar Water Heating Systems use sunlight to heat water, reducing
                electricity or fuel consumption. These systems provide reliable
                hot water throughout the year in a cost-effective and
                eco-friendly manner.
              </p>

              {/* SUITABLE FOR */}
              <div className="solar-water-usage">
                <h4 style={{ color: '#0bbcd6', textAlign: 'center' }}>Best Suitable For</h4>

                <div className="solar-usage-grid">
                  <div className="usage-card">
                    <MdHome />
                    <span>Homes & Apartments</span>
                  </div>

                  <div className="usage-card">
                    <MdLocalHospital />
                    <span>Hospitals & Nursing Homes</span>
                  </div>

                  <div className="usage-card">
                    <MdSchool />
                    <span>Hostels & Institutions</span>
                  </div>

                  <div className="usage-card">
                    <MdBuild />
                    <span>Hotels, Resorts & Industries</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>











      {/* PICTURE 2 – VIDEO WITH BG ATTACHMENT */}
      <section
        id="Picture-6"
        className="picture-section6"
        style={{ backgroundImage: `url(${SOLARWATERHEATER})` }}
      >
        <div
          className="picture-wrapper4"
          data-aos="slide-up"
          data-aos-once="false"
        >
          <video
            src={ROOFTOPWATER}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="picture-video6"
          />
        </div>
      </section>








      <section
        id="lightning-arrestor"
        className="lightning-section"
      >
        <div className="container">

          {/* TITLE */}
          <div className="text-center mb-5" data-aos="slide-up" data-aos-once="false">
            <h2 className="lightning-title">
              Lightning Arrestor
            </h2>
            <p className="lightning-intro">
              “Lightning arrestors are used wherever electrical systems need protection
              from lightning and surge damage.”
            </p>
          </div>

          {/* DESCRIPTION */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10" data-aos="slide-up" data-aos-once="false">
              <p className="lightning-text">
                A lightning arrester is a safety device installed on structures and
                power systems to protect them from damaging lightning strikes by
                providing a low-resistance path to safely divert high-voltage surges
                to the ground, preventing fires, electrical damage, and harm to people.
              </p>
            </div>
          </div>

          {/* WHERE USED */}
          <div className="row g-4 mb-5">
            <div className="col-lg-4 col-md-6" data-aos="slide-up">
              <div className="lightning-use"><MdHome /> Rooftop Solar Power Plants</div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="slide-up">
              <div className="lightning-use"><MdFactory /> Ground-Mounted Solar Plants</div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="slide-up">
              <div className="lightning-use"><MdBusiness /> Commercial & Industrial Buildings</div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="slide-up">
              <div className="lightning-use"><MdLocalHospital /> Hospitals & Institutions</div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="slide-up">
              <div className="lightning-use"><MdCellTower /> Telecom Towers & High Structures</div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="slide-up">
              <div className="lightning-use"><MdLandscape /> Open Areas & Exposed Locations</div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="slide-up">
              <div className="lightning-use"><MdElectricalServices /> Electrical Substations & Panels</div>
            </div>
          </div>

          {/* WHY RAD */}
          {/* <div className="row justify-content-center">
            <div className="col-lg-10" data-aos="slide-up" data-aos-once="false">
              <h3 className="lightning-subtitle">Why RAD EnviroNex?</h3>

              <ul className="lightning-why">
                <li><MdCheckCircle /> Proper earthing & surge protection design</li>
                <li><MdCheckCircle /> Quality-tested lightning arrestors</li>
                <li><MdCheckCircle /> Installation as per safety standards</li>
                <li><MdCheckCircle /> Complete solar system protection</li>
              </ul>
            </div>
          </div> */}

        </div>
      </section>





      {/* PICTURE 2 – VIDEO WITH BG ATTACHMENT */}
      <section
        id="Picture-2"
        className="picture-section2"
        style={{ backgroundImage: `url(${LIGHTINGARRESTER})` }}
      >
        <div
          className="picture-wrapper2"
          data-aos="slide-up"
          data-aos-once="false"
        >
          <video
            src={LIGHTINGAREESTORVID}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="picture-video2"
          />
        </div>
      </section>


      <Footer />


    </>
  )
}

